
export const NOTIFICACIONESINDI_LOADING = 'NOTIFICACIONESINDI_LOADING';
export const NOTIFICACIONESINDI_LOADED = 'NOTIFICACIONESINDI_LOADED';
export const NOTIFICACIONESINDI_ERROR = 'NOTIFICACIONESINDI_ERROR';

export const NOTIFICACIONES_LOADING = 'NOTIFICACIONES_LOADING';
export const NOTIFICACIONES_LOADED = 'NOTIFICACIONES_LOADED';
export const NOTIFICACIONES_ERROR = 'NOTIFICACIONES_ERROR';

export const CREARNOTIFICACION_ERROR = 'CREARNOTIFICACION_ERROR';
export const CREARNOTIFICACION_LOADED = 'CREARNOTIFICACION_LOADED';
export const CREARNOTIFICACION_LOADING = 'CREARNOTIFICACION_LOADING';

export const EDITARNOTIFICACION_ERROR = 'EDITARNOTIFICACION_ERROR';
export const EDITARNOTIFICACION_LOADED = 'EDITARNOTIFICACION_LOADED';
export const EDITARNOTIFICACION_LOADING = 'EDITARNOTIFICACION_LOADING';

export const DELETENOTIFICACION_ERROR = 'DELETENOTIFICACION_ERROR';
export const DELETENOTIFICACION_LOADED = 'DELETENOTIFICACION_LOADED';
export const DELETENOTIFICACION_LOADING = 'DELETENOTIFICACION_LOADING';